import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
//@ts-ignore
import h from 'virtual-dom/h';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import { validateCustomAvatarProperty,validateAvatarIsCustom,getCustomAvatar} from '../custom-avatar/custom-avatar-helper';

export default class CustomAvatar {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;
    }

    getRenderer() {
        return () => {
            let payloadBase = this.getPayload();
            if (validateCustomAvatarProperty(payloadBase)) {

                let newAvatar = getCustomAvatar(payloadBase)
                if (validateAvatarIsCustom(newAvatar, this._settings)) {
                    return h('div', {
                        className: this._settings.classNames.alightResponsePersonaIconClassName,
                        style: {
                            backgroundImage: `url("${newAvatar}")`,
                            backgroundPositionX: "0px",
                            backgroundPositionY: "0px",
                            width: "30px",
                            height: "30px",
                            backgroundSize: '30px',
                            backgroundRepeat: 'no-repeat'
                      
                        }
                    }, [])
                }
            }

            return h('div', {
                className: this._settings.classNames.alightResponsePersonaIconClassName
            }, [])
        }
    }

    getReducer()
    {
        return (state = {}) => { return state; }
    }

    getPayload(){
        let payloadBase;
        if(window.enableIVAasService)
        {
            if (window.sessionStorage?.ivaServiceJsonData) {
                payloadBase = JSON.parse(window.sessionStorage?.ivaServiceJsonData);
            }
            else{
                payloadBase = window.enableIVAasService();
            }
        }
        else
        {
        //@ts-ignore
        let windowBase = this._store.getState()[this._settings.stateLocations.Window.Base];
        payloadBase = windowBase[this._settings.stateLocations.Window.productPayload.Base];
        }
        return payloadBase;
    }

}




// WEBPACK FOOTER //
// ./modules/custom-avatar/custom-avatar.ts